import React, { useEffect, useState } from 'react';
import '../../assets/css/Workshop.css'
import AddWorkshop from './AddWorkshop';
import axios from 'axios';
import DataTable from "react-data-table-component";
import { toast, ToastContainer } from 'react-toastify';
import { Tooltip } from "react-tooltip";


function Workshops() {
  const [search, setSearch] = useState("");
  const [showForm, setShowForm] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [brands, setBrands] = useState([])
  const [page, setPage] = useState(1);
  const [workshops, setWorkshops] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);  const [selectedLead, setSelectedLead] = useState(null);
  const [selectedWorkshop, setSelectedWorkshop] = useState([]);

  const getAdminData = async () => {
    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        "https://devapi.bykit.in/api/admin/workshop/list??type=live",
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('workshop', response)

      if (response.data && response.data.data) {
        setBrands(response.data.data);
        setWorkshops(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getAdminData();
  }, []);


  const handleToggleStatus = async () => {
    if (!selectedLead) return;

    const storedLoginData = JSON.parse(localStorage.getItem("LoginData"));
    const token = storedLoginData?.token;

    try {
      const response = await axios.get(
        `https://devapi.bykit.in/api/admin/workshop/status/${selectedLead.id}??type=live`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log('manager account ', response)

      if (response.data?.status) {
        const newStatus = selectedLead.status === 1 ? 0 : 1;
        const message = newStatus === 1 ? "Workshop Account Activated Successfully" : "Workshop Account Deactivated Successfully";
        toast.success(message);

        // Update status in state
        const updatedLeads = brands.map((brands, index) =>
          index === selectedIndex ? { ...brands, status: brands.status === 1 ? 0 : 1 } : brands
        );

        setBrands(updatedLeads); // Update leads state
        setShowModal(false);
      }
    } catch (error) {
      console.error("Error updating status:", error.response?.data || error.message);
    }
  };


  const columns = [
    {
      name: "Date",
      cell: (row) => (
        <div>
          <p>{row.date || "N/A"}</p>
          <span className={`text-white font-bold ${row.status === 0 ? "deactvie_btn" : "active_btn"}`}>
            {row.status === 0 ? "Deactive" : "Active"}
          </span>
        </div>
      ),
      sortable: true
    },

    {
      name: "Workshop Name",
      selector: (row) => row.workshop,
      sortable: true,
    },
    {
      name: "Owner Name",
      selector: (row) => row.owner_name,
    },
    {
      name: "Owner Phone",
      selector: (row) => row.owner_phone,
    },
    {
      name: "Contact Person",
      selector: (row) => row.name,
    },
    {
      name: "Phone",
      selector: (row) => row.phone,
    },
    {
      name: "Email",
      selector: (row) => row.email,
    },
    {
      name: "Address",
      selector: (row) => row.address,
    },
    {
      name: "Status",
      cell: (row, index) => (
        <div className="p-3 text-center">
          <button className="edit_btn me-2"
            data-tooltip-id={`edit-tooltip-${row.id}`}
            data-tooltip-content="Edit"
            onClick={() => {
              setSelectedWorkshop(row); // Set the selected workshop
              setShowForm(true); // Show the form modal
            }}>
            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" class="iconify iconify--heroicons" width="1em" height="1em" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m16.862 4.487l1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L10.582 16.07a4.5 4.5 0 0 1-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 0 1 1.13-1.897zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0 1 15.75 21H5.25A2.25 2.25 0 0 1 3 18.75V8.25A2.25 2.25 0 0 1 5.25 6H10"></path></svg>
          </button>
          <Tooltip id={`edit-tooltip-${row.id}`} place="top" className="tooltip_bg" />
          <button
            className="workshop_btn"
            data-tooltip-id={`status-tooltip-${row.id}`}
            data-tooltip-content={row.status === 1 ? "Deactivate" : "Activate"}
            onClick={() => {
              setSelectedIndex(index);
              setSelectedLead(row); // Store the clicked row
              setShowModal(true);
            }}
          >
            {row.status === 1 ? (
              <i className="ri-close-fill" style={{ color: "#475569" }}></i>
            ) : (
              <i className="ri-check-fill" style={{ color: "#475569" }}></i>
            )}
          </button>

          <Tooltip
            id={`status-tooltip-${row.id}`}
            place="top"
            className={row.status === 1 ? "tooltip-activate" : "tooltip-deactivate"}
          />
        </div>
      ),
      width: '130px',
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];




  const handlePageChange = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (newRows) => {
    setRowsPerPage(newRows);
    setPage(1);
  };


  return (
    <div className="p-3">
      <ToastContainer></ToastContainer>
      {/* <nav
        style={{
          "--bs-breadcrumb-divider": `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8'%3E%3Cpath d='M2.5 0L1 1.5 3.5 4 1 6.5 2.5 8l4-4-4-4z' fill='currentColor'/%3E%3C/svg%3E")`
        }}
        aria-label="breadcrumb"
      >
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <Link href="#">Home</Link>
          </li>
          <li className="breadcrumb-item active" aria-current="page">
            Manage Workshop
          </li>
        </ol>
      </nav> */}

      {!showForm && (
        <>
          <div className="d-flex align-items-center gap-3">
            <svg className="custom-icon" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="20px" height="20px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m3 12l2-2m0 0l7-7l7 7M5 10v10a1 1 0 0 0 1 1h3m10-11l2 2m-2-2v10a1 1 0 0 1-1 1h-3m-6 0a1 1 0 0 0 1-1v-4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v4a1 1 0 0 0 1 1m-6 0h6"></path>
            </svg>

            <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="18px" height="18px" viewBox="0 0 24 24">
              <path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="m8.25 4.5l7.5 7.5l-7.5 7.5"></path>
            </svg>

            <p className="m-0">Manage Workshop</p>
          </div>

          <div className="managebrand_box mt-3  py-4 ">
            <div className='d-flex justify-content-between mb-2'>
              <h4 className="dashboard_head ps-3">Manage Workshop</h4>
              <div className='d-flex'>
                <input
                  type="text"
                  value={search}
                  className="manage_brand_search me-2"
                  placeholder="search"
                  onChange={(e) => setSearch(e.target.value)}
                />
                <button className="add_workshop_btn me-3" onClick={() => setShowForm(!showForm)}>
                  {showForm ? "Cancel" : "+ Add Workshop"}
                </button>
              </div>
            </div>

            <DataTable
              columns={columns}
              data={brands.filter((item) => item.name && item.name.toLowerCase().includes(search.toLowerCase()))}
              pagination
              responsive
              //paginationTotalRows={totalRows}
              paginationPerPage={rowsPerPage}
              paginationRowsPerPageOptions={[50,100, 200, 300, 400]}
              onChangePage={handlePageChange}
              onChangeRowsPerPage={handleRowsPerPageChange}
              customStyles={{
                headRow: {
                  style: {
                    backgroundColor: "#E2E8F0",
                    color: "#475569",
                    fontWeight: "600",
                  }
                },
                pagination: {
                  style: {
                    borderTop: "1px solid #ddd",
                    padding: "10px",
                    backgroundColor: "#f8f9fa"
                  }
                },
                cells: {
                  style: {
                    padding: "15px",
                    margin: "0",
                    fontSize: "16px",
                    color: "rgb(71, 85, 105);",
                  },
                },
                headCells: {
                  style: {
                    margin: "0",
                    fontSize: "18px",
                    fontWeight: "700",
                    color: "rgb(71, 85, 105);",
                  },
                },
              }}
            />
          </div>
        </>
      )}

      {showModal && (
        <div className="modal-overlay delete-overlay">
          <div className="modal-content delete-content">
            <div className="modal-header bg-dark text-white mt-0">
              <button type="button" className="btn-close btn-close-white" onClick={() => setShowModal(false)}></button>
            </div>
            <div className='p-3'>
              <p className="delete_text">
                Are you sure you want to {selectedLead?.status === 1 ? "deactivate" : "activate"} this account?
              </p>
            </div>
            <hr className='p-0 m-0'></hr>
            <div className="modal-buttons text-end p-3">
              <button onClick={() => setShowModal(false)} className='model_dlt_btn me-3'>No</button>
              <button onClick={handleToggleStatus} className='model_dlt_btn'>Yes</button>
            </div>
          </div>
        </div>
      )}

      {/* FORM SECTION */}
      {showForm && <AddWorkshop setWorkshops={setWorkshops} refreshManagers={getAdminData} setShowForm={setShowForm} selectedWorkshop={selectedWorkshop} />}

    </div>
  );
}

export default Workshops;

